<div class="not-found-body">
  <div class="not-found-container">
    <div class="not-found-icon">
      <span class="fa-regular fa-circle-exclamation"></span>
    </div>
    <div class="not-found-header">404: Page Not Found</div>
    <div class="not-found-text">
      We couldn't find the page you're looking for. It might have been moved or deleted.
    </div>
    <div class="not-found-buttons"><button class="btn btn-primary btn-lg" (click)="returnToDashboard()"><span class="fa-solid fa-house"></span>&nbsp; Return to Dashboard</button></div>
    <div class="not-found-contact">
      <div class="not-found-contact-text">Need help? Contact the <a href="mailto:IWB_Support@isg-one.com" >Workbench Support Team</a></div>
    </div>
  </div>
</div>
